import React from "react";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { axiosget } from "../../helpers/httprequest";
import ReceiptHeader from "../../components/ReceiptHeader";
import { useQuery } from "@tanstack/react-query";
import { Alert, AlertDescription } from "../../components/ui/Alert";
import is_null from "../../helpers/is_null";

const AcceptanceLetter = () => {
  const { id } = useParams();
  const { data, isLoading, error } = useQuery({
    queryKey: ["acceptanceInformation"],
    queryFn: async () => {
      const req = await axiosget(`ms_acceptance_fee_rrr/receipt/${id}`);
      return req?.data;
    },
  });
  if (!is_null(data)) {
    setTimeout(() => window.print(), 500);
  }
  return (
    <>
      {isLoading && <Loader />}
      {error && <Alert variant="danger"><AlertDescription>{`Local server error: ${error}`}</AlertDescription></Alert>}
      {data?.message !== undefined && <Alert variant="danger"><AlertDescription>{data?.message}</AlertDescription></Alert>}
      {data?.message === undefined && (
        <div className="container">
          <ReceiptHeader office={<>CLEARANCE ACCEPTANCE</>} />
          <br />
          <div className="letterto">
            <div className="">
              <b className="text-uppercase">ADM/{data?.code}</b>
            </div>
            <div className="">Date: {new Date().toDateString()}</div>
          </div>
          <br />
          <div className="body">
            <div style={{ textAlign: "justify" }}>
              I,{" "}
              <b>
                <u>
                  {data?.applicant?.firstname} {data?.applicant?.middlename} {data?.applicant?.lastname}
                </u>
              </b>{" "}
              hereby accept the admission offered to me and pledge to abide by the rules and regulations of the college.
            </div>

            <div className="text-center">
              Signature & Date (Below)
              <br />
              <br />
              <br />
              ......................................................................
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AcceptanceLetter;
